var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"vid-icon text-center d-none d-lg-inline-block"},[(_vm.showIcon)?_c('img',{staticClass:"w-10 h-10 transition-transform duration-300 hover:scale-110 cursor-pointer",attrs:{"src":_vm.iconSrc,"alt":"Play icon"},on:{"click":function($event){$event.stopPropagation();return _vm.openVideo.apply(null, arguments)}}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }